/* eslint-disable */
export default {
  loading: '로드 중...',
} as const;

// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
